(() => {
  const page = document.querySelector('[data-ov3]');
  if (!page) return;
  const thumbs = [...page.querySelectorAll('[data-ov3-thumb]')];
  const images = [...page.querySelectorAll('[data-ov3-image]')];
  const current = page.querySelector('[data-ov3-current]');
  thumbs.forEach((button) => button.addEventListener('click', () => {
    const index = Number(button.dataset.ov3Thumb);
    thumbs.forEach((item) => item.setAttribute('aria-current', String(item === button)));
    images.forEach((item) => item.classList.toggle('is-active', Number(item.dataset.ov3Image) === index));
    if (current) current.textContent = String(index + 1).padStart(2, '0');
  }));

  const today = page.querySelector('[data-ov3-today]');
  const deliveryRange = page.querySelector('[data-ov3-delivery-range]');
  if (today || deliveryRange) {
    const now = new Date();
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'Europe/Bucharest'
    }).formatToParts(now).filter((part) => part.type !== 'literal').map((part) => [part.type, Number(part.value)]));
    const dayAtNoon = (offset) => new Date(Date.UTC(parts.year, parts.month - 1, parts.day + offset, 12));
    const format = new Intl.DateTimeFormat('ro-RO', {
      day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Europe/Bucharest'
    });
    if (today) today.textContent = format.format(dayAtNoon(0));
    if (deliveryRange) deliveryRange.textContent = `${format.format(dayAtNoon(1))} – ${format.format(dayAtNoon(3))}`;
  }

  page.querySelectorAll('[data-ov3-buy]').forEach((button) => button.addEventListener('click', () => {
    const appButton = document.querySelector('#_rsi-cod-form-embed-custom-hook ._rsi-buy-now-button, #_rsi-buy-now-button');
    if (appButton) appButton.click();
  }));

  const compare = page.querySelector('[data-ov3-compare]');
  if (compare) {
    const range = compare.querySelector('input[type=range]');
    if (range) range.addEventListener('input', () => compare.style.setProperty('--ov3-pos', range.value + '%'));
  }

  const tabs = [...page.querySelectorAll('[data-ov3-step]')];
  const panels = [...page.querySelectorAll('[data-ov3-panel]')];
  const stepImages = [...page.querySelectorAll('[data-ov3-step-image]')];
  const stepCount = page.querySelector('[data-ov3-step-count]');
  function selectStep(index, focus) {
    tabs.forEach((button) => {
      const selected = Number(button.dataset.ov3Step) === index;
      button.setAttribute('aria-selected', String(selected));
      button.tabIndex = selected ? 0 : -1;
      if (selected && focus) button.focus();
    });
    panels.forEach((panel) => {
      const selected = Number(panel.dataset.ov3Panel) === index;
      panel.hidden = !selected;
      panel.classList.toggle('is-active', selected);
    });
    stepImages.forEach((image) => image.classList.toggle('is-active', Number(image.dataset.ov3StepImage) === index));
    if (stepCount) stepCount.textContent = String(index + 1).padStart(2, '0');
  }
  tabs.forEach((button, index) => {
    button.addEventListener('click', () => selectStep(index, false));
    button.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      selectStep(next, true);
    });
  });
})();
